//provider
export const getProvidersSelector = (state) => state.providers;

//business
export const selectAllBrandsDependsOnBusinessGroup = (state) =>
  state.business?.allBrandsDependsOnBusinessGroup;
export const selectSelectedBrands = (state) => state.business?.selectedBrands;
export const selectUnSelect = (state) => state.business?.unSelect;
export const selectSelectedLocations = (state) =>
  state.business?.selectedLocations;
export const selectLocationIdsForReport = (state) =>
  state.business?.locationIdsForReport;
export const selectAllLocationsDependsOnBusinessGroup = (state) =>
  state.business?.allLocationsDependsOnBusinessGroup;
export const selectAllFilterBrandList = (state) =>
  state.business?.filterBrandList;
export const selectAllLocations = (state) => state.business?.allLocations;
export const selectAllBrandIdsForReport = (state) =>
  state.business?.brandIdsForReport;
export const selectAllBusinessGroups = (state) =>
  state.business?.allBusinessGroups;
export const selectCurrentBusiness = (state) => state.business?.currentBusiness;
export const selectBusinessInventoryList = (state) =>
  state.inventory?.businessInventoryList;
export const selectBusinessInventoryListLoading = (state) =>
  state.inventory?.businessInventoryListLoading;
export const selectIsDisabled = (state) => state.inventory?.isDisabled;
export const selectCategoriesByMenu = (state) =>
  state.inventory?.categoriesByMenu;
export const selectCategoriesTotalCount = (state) =>
  state.inventory?.categoriesTotalCount;
export const selectCategoriesChangeCount = (state) =>
  state.inventory?.categoriesChangeCount;
export const selectProductsByCategory = (state) =>
  state.inventory?.productsByCategory;
export const selectProductsByMenu = (state) => state.inventory?.productsByMenu;
export const selectProductsTotalCount = (state) =>
  state.inventory?.productsTotalCount;
export const selectProductsChangeCount = (state) =>
  state.inventory?.productsChangeCount;
export const selectTotalInventory = (state) =>
  state.inventory?.totalInventory;
export const selectTotalCost = (state) => state.inventory?.totalCost;
export const selectTotalSales = (state) => state.inventory?.totalSales;

//menu
export const selectCurrentMenu = (state) => state.menu?.menu;

//report
export const selectFilterListReport = (state) => state.reports?.filterList;

//user
export const selectUserBusinessListReport = (state) =>
  state.user?.data?.businessList;

//PRINTERS

export const selectPrinterList = (state) => state?.printers?.list;
export const selectPrinterTagsList = (state) =>
  state?.printers?.printerTagsList;

//mev3
export const selectCurrentSelectedBrand = (state) =>
  state.mev3?.currentSelectedBrand;
export const selectBrandList = (state) => state.mev3?.brandList;
export const selectPagination = (state) => state.mev3?.pagination;
export const selectIsBrandLoading = (state) => state.mev3?.isBrandLoading;
export const selectFetchMoreDataLoading = (state) =>
  state.mev3?.fetchMoreDataLoading;
export const selectLocationList = (state) => state.mev3?.locationList;
export const selectCurrentSelectedLocation = (state) =>
  state.mev3?.currentSelectedLocation;
export const selectFilteredLocationList = (state) =>
  state.mev3?.filteredLocationList;
export const selectFilteredBrandList = (state) => state.mev3?.filteredBrandList;
export const selectPaginationSearchBrand = (state) =>
  state.mev3?.paginationSearchBrand;
export const selectSearchLoading = (state) => state.mev3?.searchLoading;
export const selectShowOnlyActiveBusinesses = (state) =>
  state.mev3?.showOnlyActiveBusinesses;

export const selectIsMev3BrandLoading = (state) => state.mev3?.isBrandLoading;
export const connectedProvidersReport = (state) =>
  state.providers?.connectedProvidersReport;
